module.exports = __webpack_public_path__ + "static/img/Zac-Williams.9812b45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Zac-Williams.jpg
// module id = Ghx8
// module chunks = 0